import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { IconButton, Tooltip, withStyles, Typography } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import * as actions from './store/remoteAssetsActions';
import { BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import { connect } from 'react-redux';
import RemoveRemoteAssetsModal from './RemoveRemoteAssetsModal'

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    typography: {
        marginTop: '8%'
    },
    title: {
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const RemoteAssetsList = props => {
    const { classes, handleCloseDanger, translations, handleRemoveDevice, fetchDeviceOnlineDataCount, activeCustomerID, tableColumns, fetchDeviceOnlineData, tableActions, onlineDeviceInfo, tableRef } = props;

    const columnObject = useMemo(() => tableColumns, [tableColumns]);

    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        exportFileName: 'RemoteAssets',
        filterCellStyle: { maxWidth: '200px' },
        search: false,
        minBodyHeight: window.innerHeight - 198 < 300 ? 300 : window.innerHeight - 198,
        maxBodyHeight: window.innerHeight - 198,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
        },
        columnsButton: true,
        pageSize: 50,
        emptyRowsWhenPaging: false
    });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    };

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        const queryToSend = {
            ActiveCustomerID: activeCustomerID,
            q: q
        };
        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;
        let count = await fetchDeviceOnlineDataCount(queryToSend);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            queryToSend['pageSize'] = dimensions.pageSize;
            queryToSend['page'] = query.page;
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchDeviceOnlineData(queryToSend) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const tableTitle = () => {
        return <div className={classes.title}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography>  {translations["remote_assets"] || 'Remote assets'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    };

    return <>
        <MaterialTable
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            localization={localization(translations)}
            actions={tableActions}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {onlineDeviceInfo.onlineDeviceDialog ?
            <RemoveRemoteAssetsModal
                handleCloseDanger={handleCloseDanger}
                handleRemoveDevice={handleRemoveDevice}
                translations={translations}
                deviceOnlineModalState={onlineDeviceInfo} />
            : null}
    </>
}

const mapDispatchToProps = dispatch => {
    return {
        fetchDeviceOnlineDataCount: filter => dispatch(actions.fetchDeviceOnlineDataCount(filter)),
        fetchDeviceOnlineData: filter => dispatch(actions.fetchDeviceOnlineData(filter))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(RemoteAssetsList));